<template>
  <v-row>
    <view-user
      :auths="authsSelectedUser"
      customComponent="Tasks"
      :user-id="selectedUserId"
      v-model="viewUserDialog"
      @getUsers="getPendingTasks"/>

    <v-col cols="12" class="py-0 pl-0">
      <v-card-title>
        {{$t('general.pendingTasks')}}
        <v-spacer></v-spacer>
        <v-switch color="kbLightBlue" class="pt-2 mb-0 mt-2" v-if="showSwitchWithoutResponsible"
                  :label="$t('general.showWithoutResponsible') "
                  v-model="showWithoutResponsibleTasks"></v-switch>
      </v-card-title>
    </v-col>
    <v-col cols="12" style="overflow: auto;white-space: nowrap;">
      <v-data-table
        style="min-width: 600px;"
        dense
        disable-sort
        disable-filtering
        fixed-header
        height="300"
        :headers="this.headers"
        :items="taskData"
        class="elevation-1"
        :options.sync="pagination"
        :footer-props="{
          'items-per-page-text': $t('general.tasksPerPage'),
          'items-per-page-options': [10, 50, 100]
         }"
        :server-items-length="taskTotal">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.userName || $t('general.noName')}}</td>
            <td class="font-weight-bold">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-icon :color="colorBasedOnDiff(item.diff)"
                          class="mr-2"
                          style="cursor: pointer"
                          size="small"
                          v-on="on">
                    mdi-brightness-1
                  </v-icon>
                </template>

                <span>
                  {{ statusBasedOnDiff(item.diff) }}
                </span>
              </v-tooltip>
              {{ item.name || $t('general.noName') }}

            </td>
            <td>{{ item.date | moment('DD/MM/YYYY') }}</td>
            <td>{{ item.date | moment('hh:mmA') }}</td>
            <td class="text-center">
              <v-btn icon @click="showUser(item)" color="kbDarkBlueText" text>
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <v-row>
            <v-col class="text-center" cols="12" v-if="taskData.length > 0">
              {{$t('general.loadingTasks')}}
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              {{$t('general.noTasksRegistered')}}
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Tasks from '@/mixins/Tasks'
import TimeZones from '@/mixins/TimeZones'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser.vue'

export default {
  components: {
    ViewUser
  },
  computed: {
    ...mapGetters(['selectedApp', 'administratorRoles', 'withoutResponsibleTasksNotifications', 'userTasksNotifications']),
    ...mapState({
      userKeybe: state => state.auth.userKeybe,
      totalPendingTasks: state => state.usersTasks.totalPendingTasks,
      withoutResponsibleTasksTotal: state => state.usersTasks.withoutResponsibleTasksTotal
    }),
    headers () {
      return [
        { text: this.$t('general.userName'), value: 'userName' },
        { text: this.$t('general.taskName'), value: 'taskName' },
        { text: this.$t('general.date'), value: 'shortDate' },
        { text: this.$t('general.hour'), value: 'time' },
        { text: this.$t('general.details'), value: 'actions', align: 'center' }
      ]
    },
    taskData () {
      return this.showWithoutResponsibleTasks ? this.withoutResponsibleTasksNotifications : this.userTasksNotifications
    },
    taskTotal () {
      return this.showWithoutResponsibleTasks ? this.withoutResponsibleTasksTotal : this.totalPendingTasks
    },
    showSwitchWithoutResponsible () {
      return (
        this.userKeybe.type === 'superadmin' ||
        this.administratorRoles.includes('ROLE_RECORDS_VIEW_ALL') ||
        this.administratorRoles.includes('ROLE_ADMIN')
      )
    }
  },
  data () {
    return {
      authsSelectedUser: [],
      pagination: {},
      selectedUserId: '',
      selectedUsers: [],
      viewUserDialog: false,
      showWithoutResponsibleTasks: false
    }
  },
  methods: {
    async getPendingTasks () {
      this.$store.commit('SET_TASK_PAGINATION', this.pagination)
      await this.$store.dispatch('getTasksNotifications')
    },
    showUser (user) {
      this.selectedUserId = user.UUID || user.userId
      this.authsSelectedUser = user.auths
      this.viewUserDialog = true
    },
    chooseStateColor (task) {
      switch (task) {
        case -1:
          return 'error'
        case 0:
          return 'warning'
        case 1:
          return 'success'
      }
    }
  },
  mixins: [Tasks, TimeZones],
  watch: {
    pagination: {
      handler () {
        this.getPendingTasks()
      },
      deep: true
    },
    selectedApp: {
      handler () {
        this.getPendingTasks()
      }
    }
  }
}
</script>

<style scoped>

</style>
